import React from 'react';
import Button from '../../../Button';
import { viewLoading } from '../../../../utils/loading';
import { isEmpty } from '../../../../utils/lodashExtend';
import { taxSingoFileConverter } from '../../../../utils/taxPortal/tax-singo';


const taxSingoDownload = (props) => {
  viewLoading(true)
  const { linkSource, fileName } = taxSingoFileConverter(props)
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
  viewLoading(false)
}

const TaxSingoItemDownload = (props) => {

  const { data = {},
    scheduled,
    taxpayerSingo,
    taxpayer,
    name = '',
  } = props


  const downloadClick = () => {
    if (name === '납부서') {
      const array = taxpayerSingo.electronicData.listPdfPath2

      for (let index = 0; index < array.length; index++) {
        const pdf = array[index]?.pdfHex2;
        // taxpayerSingo.electronicData.listPdfPath2[0].pdfHex2
        if (pdf) {
          taxSingoDownload({ data: pdf, scheduled, taxpayer, name })
        }
      }

    } else {
      taxSingoDownload({ data, scheduled, taxpayer, name })
    }
  }

  // const convertCounselingData = () => { }

  return <div className='tax-singo-item-wrap'>
    <div className="tax-singo-item-box">
      <div className='tax-singo-item-value'>
        {!isEmpty(data) ? <i className="bx bx-download" style={{ fontSize: '20px' }}></i> : '-'}
      </div>
      {!isEmpty(data) &&
        <div className='tax-singo-item-drop-box'>
          <div className='tax-sing-item-drop-box-header'>
            {/* {data.name} */}
          </div>
          <div className="tax-singo-item-bottom">
            <Button
              label={'다운로드'}
              size="tiny"
              color="dark"
              onClick={() => downloadClick()}
            />
            {/* <Button
              label={'전송'}
              size="tiny"
              color="info"
              onClick={() => convertCounselingData(true)}
            /> */}
          </div>
        </div>
      }
    </div>
  </div>
}

export default TaxSingoItemDownload

export { taxSingoDownload }